module.exports = __webpack_public_path__ + "static/media/Freddie.ef6e2c66.png";